module.exports = __webpack_public_path__ + "static/media/headerbild-min.4b3f2ebf.jpg";